
const al = document.querySelector(".anchorlinks")

if (al) {
    const links = al.querySelector(".links")
    let linksCount = 0
    document.querySelectorAll(".main-content a[id]").forEach(anchor => {
        const listItem = document.createElement("li")
        const link = document.createElement("a")

        const img = document.createElement("img")
        img.src = "/img/arrow-down.svg"
        img.setAttribute("height", "12")
        img.setAttribute("width", "10")
        img.setAttribute("alt", "")

        const imgDark = document.createElement("img")
        imgDark.src = "/img/arrow-down-dark.svg"
        imgDark.setAttribute("class", "dark")
        imgDark.setAttribute("height", "12")
        imgDark.setAttribute("width", "10")
        imgDark.setAttribute("alt", "")


        link.href = "./#" + anchor.id
        link.textContent = anchor.parentElement.textContent

        link.appendChild(img);
        link.appendChild(imgDark);

        link.addEventListener("click", () => {
            link.closest("#al-links").classList.remove("show");
            link.closest(".menu").querySelectorAll(".label").forEach(lbl => {
                lbl.querySelector("span").setAttribute("aria-expanded", "false")
            })
        })
        listItem.appendChild(link)
        links.appendChild(listItem)
        linksCount++
    })
    if (linksCount == 0) {
        al.style.display = "none"
    }
};